import { IProjectMacra1 } from '../../store/project/projectSlice';
import BeMaccaferriCalculationProvider from './BeMaccaferriCalculationProvider';

//CALCULATION
export const getResultsAsync = async (data: IProjectMacra1) => BeMaccaferriCalculationProvider.getResultsAsync(data);
